export default "__VITE_ASSET__C4Dv5lLq__"